
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { AgentInteractionService } from 'src/app/services/agent-interaction.service';
import { ApiService } from 'src/app/services/api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../../models/Constants';
import { MatTableDataSource } from '@angular/material/table';
import { AlightTableComponent } from '../../common/alight-table/alight-table.component';
import { columnsModel } from 'src/app/models/customer.model';
import { CustBusService } from '../../../services/customer-search-bussiness-logic.service';
import _, { slice } from 'lodash';
import { Tab } from 'src/app/models/tab.model';


export interface PeriodicElement {
  channel: string;
  date: string;
  startTime: string;
  customer: string;
  client: string;
  topic: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { channel: 'phone-arrow-up-right', date: 'Jan-01-1901', startTime: '10:43:58 a.m.', customer: 'Ankita', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: '-messages', date: 'Jan-01-1901', startTime: '10:03:00 a.m.', customer: 'Amarjeet', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 'phone-arrow-down-left', date: 'Jan-01-1901', startTime: '10:43:58 a.m.', customer: 'Vamsi', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: '-user', date: 'Jan-01-1901', startTime: '09:40:58 a.m.', customer: 'Pooja Gupta', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 'phone-arrow-up-right', date: 'Jan-01-1901', startTime: '10:43:58 a.m.', customer: 'Shweta', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: '-messages', date: 'Jan-01-1901', startTime: '08:43:50 a.m.', customer: 'Asha', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 'phone-arrow-up-right', date: 'Jan-01-1901', startTime: '10:43:58 a.m.', customer: 'Shweta Goel', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 't', date: 'Jan-01-1901', startTime: '07:57:50 a.m.', customer: 'Amaresh Sri', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 'phone-arrow-down-left', date: 'Jan-01-1901', startTime: '07:40:38 a.m.', customer: 'Ankush Kapoor', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },
  { channel: 'phone-arrow-up-right', date: 'Jan-01-1901', startTime: '06:01:00 a.m.', customer: 'Pankaj Sharma', client: 'Premier', topic: 'Txxxxxxxxxxxx...' },


];

@Component({
  selector: 'app-agent-interaction-history',
  templateUrl: './agent-interaction-history.component.html',
  styleUrls: ['./agent-interaction-history.component.scss']
})
export class AgentInteractionHistoryComponent implements OnInit {

  @ViewChild(AlightTableComponent) alightTable;

  dataSource = ELEMENT_DATA;

  @Output()
  setDashboardPagination: EventEmitter<any> = new EventEmitter();

  AgentIHViewLoader: boolean = false;
  apiFailed: boolean = false;
  showLoaderMsg: boolean = false;
  loaderTimeoutId: any;
  totalRecords: number = 0;
  apiFailureMsg = Constants.AGENT_IH_CARD_DATA_FAILURE_MSG;
  agentClientAccessMsg = Constants.AGENT_IH_CLIENT_ACCESS;
  loaderType = Constants.LOADER_TYPE.CARD;
  isUnknownCallerAlert: boolean = false;
  alertMessageForUnknownCaller =Constants.YELLOW_ALERT_MESSAGE;


  constructor(public rootScope: RootScopeService,
    public cusBusService: CustBusService, public agentInteractionService: AgentInteractionService, private apiService: ApiService) { }

  ngOnInit(): void {
    if(!this.rootScope.isAgentFilterApplied){   

    if (this.rootScope.lanId !== null) {
      this.fetchAgentInteractionData();
    } else {
      /* istanbul ignore next */
      setTimeout(() => {
        this.fetchAgentInteractionData();
      }, 200)
    }
  }
    this.rootScope.agenIneractionData.isAgentClientAccess = true;
  }

  /**
   * Below method is used to fetch agent Interaction from 
   * Document DB
   */
  fetchAgentInteractionData() {

    this.AgentIHViewLoader = true;

    // let paramsObject = {
    //   userLanId: sessionStorage.getItem("lanId")
    // };

    this.apiService.getAgentInteractionData().subscribe({
      next: (data: any) => {

        if (data['data'] && data['data'].length > 0) {
          this.agentInteractionService.modifyAgentIHViewData(data['data']);
          this.totalRecords =
            this.agentInteractionService.agentInteractionHistoryTableData.data.length;

          this.setAgentInteractionTableData();       
        } else {
          console.log('No Data found when getAgentInteractionData called', data);
          this.agentInteractionService.agentInteractionHistoryTableData = new MatTableDataSource([]);
          this.agentInteractionService.agentIHFilterDataMap = new MatTableDataSource([]);
        }
        this.AgentIHViewLoader = false;
        //this.rootScope.isAgentFilterApplied = false;
        //this.agentInteractionService.agentFilterFormData = null;
      },
      error: (error) => {
        // Handle errors
        console.error('Error occurred:', error);
        this.apiFailed = true;
        this.AgentIHViewLoader = false;
        this.showLoaderMsg = false;
        clearTimeout(this.loaderTimeoutId);
      }
    });
  }



  openFilter() {
    this.rootScope.openFilterDialog = true;
    this.isUnknownCallerAlert= false;
    this.rootScope.agenIneractionData.isAgentClientAccess = true;
  }

  closeFilter() {
    this.rootScope.openFilterDialog = false;
  }

  startTimerForLoader() {
    let that = this;
    /* istanbul ignore next */
    this.loaderTimeoutId = setTimeout(() => {
      that.showLoaderMsg = true;
    }, 1 * this.rootScope.showLoaderMsgThreshold * 1000);
  }

  setAgentInteractionTableData() {
    /*istanbul ignore next */
    setTimeout(() => {
      this.agentInteractionService.setAgentIHTableData(
        this,
        this.totalRecords
      );
      this.alightTable?.setGridSortAndPagination();

    }, 200);
  }

  clearFilter() {
    this.fetchAgentInteractionData();
    this.isUnknownCallerAlert = false;
    this.rootScope.agenIneractionData.isAgentClientAccess = true;
    this.rootScope.isAgentFilterApplied = false;
    this.agentInteractionService.agentFilterFormData=null
  }
  onTableRowEnter(row) {
    this.onDoubleClick(row)
  }

  onDoubleClick(selectedRow, event?) {

    //Code changes for CCR1-6517
    if (selectedRow?.customer === Constants.buttonEnum.unknownCaller || selectedRow?.contact?.id === 'N/A') {
      this.isUnknownCallerAlert = true;
      return;
    } else {
      this.isUnknownCallerAlert = false;
    }

    this.rootScope.agenIneractionData.isAgentClientAccess = true;
    if (!selectedRow?.contact?.id || selectedRow?.contact?.id == 'N/A' || this.rootScope.isLiveCall || this.rootScope.isLiveChat) {
      return;
    }
    if (!this.checkClientAccess(selectedRow?.clientId)) {
      return;
    }

    let data = {
      row: selectedRow,
      buttonName: ''
    }
    this.rootScope.agenIneractionData.selectedRow = selectedRow;
    this.rootScope.agenIneractionData.event = event;
    this.cusBusService.parentData = null;
    this.cusBusService.openAdditonalAcc = null;
    this.rootScope.agenIneractionData.isAgentRowClicked = true;

    data.row.customerType = 'ACH';
    data.row.clientId = selectedRow?.clientId;
    data.row.udpId = selectedRow?.contact?.id;

    this.rootScope.activeLink = 'search';
    let previouslyOpenedTab = _.findIndex(
      this.rootScope.customerTabs,
      (each) => each.conversationId == 'NA' && each.id == data?.row?.udpId
    );
    if (previouslyOpenedTab > 0) {
      return this.redirectToExAccount(
        this.rootScope.customerTabs[previouslyOpenedTab]
          ?.customerSessionId
      );
    }
    else {

      this.cusBusService.getPersonData(data);
      this.rootScope.custSearchLoader = true;
    }


  }

  //Code changes for CCR1-6517
  onSingleClick(rowData: any) {
    if (rowData.customer !== Constants.buttonEnum.unknownCaller) {
      this.isUnknownCallerAlert = false;
    }
  }

  //Code changes for CCR1-6517
  onTabClick(event: any){
    this.isUnknownCallerAlert= false;
    this.rootScope.agenIneractionData.isAgentClientAccess = true;

  }

  /* istanbul ignore next */
  redirectToExAccount(customerSessionId) {
    this.cusBusService.updateActiveTabDetails(customerSessionId);
    this.rootScope.customerLink = customerSessionId;
    this.cusBusService.routeToActiveTab(customerSessionId);
    return;
  }

  checkClientAccess(clientId) {
    const filteredclient = _.find(this.cusBusService?.clients, (x) => {
      return x.clientId === clientId
    });
    if (filteredclient) {
      return true;
    }
    this.rootScope.agenIneractionData.isAgentClientAccess = false;
    return false;
  }
}
